module.exports = __webpack_public_path__ + "static/img/1-2.df5e4ec.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/1-2.png
// module id = 6E7y
// module chunks = 0